export default __webpack_public_path__ + "static/media/thumbnail_image_9.1bb3ef1b.png";